module.exports = __webpack_public_path__ + "img/avatar-tall_all.d5b7bb21.png";